"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var events = exports.events = { CLICKED_ELEMENT: "Clicked Element" };
var track = function track(event, properties, options, callback) {
  window.analytics.track(event, properties, options, callback);
};
var page = function page(category, name, properties, options, callback) {
  window.analytics.page(category, name, properties, options, callback);
};
var trackClickedElement = exports.trackClickedElement = function trackClickedElement(element_name, option_title) {
  window.analytics.track(events.CLICKED_ELEMENT, {
    element_name: element_name,
    option_title: option_title
  });
};
var trackPage = exports.trackPage = function trackPage() {
  return window.analytics.page();
};
exports.default = {
  events: events,
  track: track,
  trackClickedElement: trackClickedElement,
  page: page
};

